var convert = require('./convert'),
    func = convert('flatMap', require('../flatMap'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/fp/flatMap.js
// module id = 1622
// module chunks = 1